import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { updateProductCategory } from "@redux/action/productFiltersAction";

const CategorySection = styled.section`
  width: 840px;
  height: 460px;

  display: flex;
  flex-direction: column;

  background: #ffffff;

  border-radius: 0 0 10px 10px;

  overflow: hidden;

  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.1);
`;

const CategoryHeader = styled.div`
  flex: 0 0 52px;

  display: flex;
  align-items: center;

  height: 52px;

  padding: 0 20px;

  border-bottom: 1px solid #e8eaec;

  background: #ffffff;

  .title {
    color: #222222;

    font-size: 18px;
    font-weight: 800;

    letter-spacing: -0.4px;
  }

  .description {
    margin-left: 10px;

    color: #92979c;

    font-size: 13px;
    font-weight: 400;
  }
`;

const CategoryBody = styled.div`
  flex: 1;

  display: grid;

  grid-template-columns: 300px 540px;

  min-height: 0;
`;

const MainArea = styled.div`
  height: 100%;

  overflow-y: auto;
  overflow-x: hidden;

  background: #f7f8f9;

  border-right: 1px solid #e5e7e9;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d5d9dc;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const MainList = styled.ul`
  width: 100%;

  margin: 0;
  padding: 6px 0;

  list-style: none;
`;

const MainItem = styled.li`
  width: 100%;
`;

const MainButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  height: 52px;

  padding: 5px 38px 5px 14px;

  border: none;

  background: ${({ $active }) =>
    $active ? "#ffffff" : "transparent"};

  color: ${({ $active }) =>
    $active ? "#2da66f" : "#333333"};

  cursor: pointer;

  transition:
    background 0.12s ease,
    color 0.12s ease;

  &::before {
    content: "";

    position: absolute;

    left: 0;
    top: 8px;
    bottom: 8px;

    width: 3px;

    border-radius: 0 3px 3px 0;

    background: ${({ $active }) =>
      $active ? "#3bb77e" : "transparent"};
  }

  &::after {
    content: "›";

    position: absolute;

    right: 14px;
    top: 50%;

    transform: translateY(-50%);

    color: ${({ $active }) =>
      $active ? "#2da66f" : "#afb4b8"};

    font-size: 20px;
  }

  &:hover {
    background: #ffffff;
    color: #2da66f;
  }

  &:hover::after {
    color: #2da66f;
  }
`;

const MainImage = styled.div`
  flex: 0 0 38px;

  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 11px;

  border-radius: 6px;

  background: #ffffff;

  overflow: hidden;

  img {
    display: block;

    width: 100%;
    height: 100%;

    padding: 2px;

    object-fit: contain;
  }
`;

const MainName = styled.span`
  min-width: 0;

  color: inherit;

  font-size: 15px;

  font-weight: ${({ $active }) =>
    $active ? "700" : "600"};

  line-height: 1.3;

  letter-spacing: -0.25px;

  text-align: left;

  word-break: keep-all;
`;

const SubArea = styled.div`
  height: 100%;

  padding: 24px 28px;

  background: #ffffff;

  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dedede;
    border-radius: 10px;
  }
`;

const SubHeader = styled.div`
  padding-bottom: 12px;

  margin-bottom: 12px;

  border-bottom: 2px solid #333333;
`;

const SubTitle = styled.button`
  display: flex;
  align-items: center;

  margin: 0;
  padding: 0;

  border: none;

  background: transparent;

  color: #222222;

  font-size: 21px;
  font-weight: 800;

  letter-spacing: -0.5px;

  cursor: pointer;

  transition: color 0.15s ease;

  &::after {
    content: "›";

    margin-left: 7px;

    color: #3bb77e;

    font-size: 21px;
    font-weight: 400;
  }

  &:hover {
    color: #2da66f;
  }
`;

const SubDescription = styled.div`
  margin-bottom: 18px;

  color: #7f858a;

  font-size: 13px;

  line-height: 1.6;

  letter-spacing: -0.15px;

  word-break: keep-all;
`;

const SubCategoryTitle = styled.div`
  margin-bottom: 7px;

  color: #555b60;

  font-size: 13px;
  font-weight: 700;
`;

const SubList = styled.ul`
  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  width: 100%;

  margin: 0;
  padding: 0;

  column-gap: 24px;

  list-style: none;
`;

const SubItem = styled.li`
  min-width: 0;
`;

const SubButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  min-height: 40px;

  padding: 6px 24px 6px 11px;

  border: none;
  border-bottom: 1px solid #f0f1f2;

  background: transparent;

  color: #555b60;

  font-size: 15px;
  font-weight: 500;

  line-height: 1.4;

  text-align: left;
  word-break: keep-all;

  cursor: pointer;

  transition:
    color 0.12s ease,
    background 0.12s ease,
    padding-left 0.12s ease;

  &::before {
    content: "";

    flex: 0 0 4px;

    width: 4px;
    height: 4px;

    margin-right: 8px;

    border-radius: 50%;

    background: #b8bdc1;
  }

  &::after {
    content: "›";

    position: absolute;

    right: 5px;
    top: 50%;

    transform: translateY(-50%);

    color: #c2c6c9;

    font-size: 17px;
  }

  &:hover {
    padding-left: 14px;
    background: #f7fcf9;
    color: #2da66f;
  }

  &:hover::before {
    background: #3bb77e;
  }

  &:hover::after {
    color: #3bb77e;
  }
`;

const EmptySub = styled.div`
  padding: 15px 0;

  color: #999999;

  font-size: 13px;
`;

const CategoryProductMenu = ({
  dummyList,
  updateProductCategory,
}) => {
  const router = useRouter();

  const currentEname = router.query.slug;

  const [category, setCategory] = useState([]);
  const [hoverCategory, setHoverCategory] = useState(null);

  const selectCategory = (item) => {
    if (!item?.ename) return;

    router.push(`/products/${item.ename}/`);
  };

  const selectSubCategory = (item, hashTag) => {
    if (!item?.ename || !hashTag) return;

    router.push(
      `/products/${item.ename}/${encodeURIComponent(hashTag)}/`
    );
  };

  useEffect(() => {
    if (!Array.isArray(dummyList?.category)) {
      setCategory([]);
      setHoverCategory(null);

      return;
    }

    const filtered = dummyList.category
      .filter((item) => item.division === "S")
      .sort((a, b) => {
        const rankA = Number(a.ranks ?? 999);
        const rankB = Number(b.ranks ?? 999);

        if (rankA !== rankB) {
          return rankA - rankB;
        }

        return String(a.name).localeCompare(
          String(b.name),
          "ko"
        );
      });

    setCategory(filtered);

    updateProductCategory(filtered);

    const current =
      filtered.find(
        (item) => item.ename === currentEname
      ) || filtered[0];

    setHoverCategory(current || null);
  }, [
    dummyList?.category,
    currentEname,
    updateProductCategory,
  ]);

  return (
    <CategorySection>
      <CategoryHeader>
        <span className="title">
          전체 카테고리
        </span>

        <span className="description">
          카테고리에 마우스를 올리면 세부 항목을 확인할 수 있습니다
        </span>
      </CategoryHeader>

      <CategoryBody>
        {/* 1차 카테고리 */}
        <MainArea>
          <MainList>
            {category.map((item) => {
              const active =
                hoverCategory?.code === item.code;

              return (
                <MainItem
                  key={
                    item.code ||
                    item.ename ||
                    item.name
                  }
                >
                  <MainButton
                    type="button"
                    $active={active}
                    onMouseEnter={() =>
                      setHoverCategory(item)
                    }
                    onFocus={() =>
                      setHoverCategory(item)
                    }
                    onClick={() =>
                      selectCategory(item)
                    }
                  >
                    <MainImage>
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.name}
                        />
                      )}
                    </MainImage>

                    <MainName
                      $active={active}
                    >
                      {item.name}
                    </MainName>
                  </MainButton>
                </MainItem>
              );
            })}
          </MainList>
        </MainArea>

        {/* 2차 카테고리 */}
        <SubArea>
          {hoverCategory ? (
            <>
              <SubHeader>
                <SubTitle
                  type="button"
                  onClick={() =>
                    selectCategory(
                      hoverCategory
                    )
                  }
                >
                  {hoverCategory.name}
                </SubTitle>
              </SubHeader>

              {hoverCategory.sub_name && (
                <SubDescription>
                  {hoverCategory.sub_name}
                </SubDescription>
              )}

              {Array.isArray(
                hoverCategory.hashTag
              ) &&
              hoverCategory.hashTag.length >
                0 ? (
                <>
                  <SubCategoryTitle>
                    세부 카테고리
                  </SubCategoryTitle>

                  <SubList>
                    {hoverCategory.hashTag.map(
                      (hashTag, index) => (
                        <SubItem
                          key={`${hoverCategory.code}-${hashTag}-${index}`}
                        >
                          <SubButton
                            type="button"
                            onClick={() =>
                              selectSubCategory(
                                hoverCategory,
                                hashTag
                              )
                            }
                          >
                            {hashTag}
                          </SubButton>
                        </SubItem>
                      )
                    )}
                  </SubList>
                </>
              ) : (
                <EmptySub>
                  세부 카테고리가 없습니다.
                </EmptySub>
              )}
            </>
          ) : (
            <EmptySub>
              카테고리를 선택해주세요.
            </EmptySub>
          )}
        </SubArea>
      </CategoryBody>
    </CategorySection>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

const mapDispatchToProps = {
  updateProductCategory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryProductMenu);